import Cart from '../cart';
export default class TcApiCart {
    getTotalValue() {
        return Cart.getSummary().then((summary) => {
            return summary.products_summary.total_value;
        });
    }
    getProductsValue() {
        return Cart.getSummary().then((summary) => {
            return summary.products_summary.products_value;
        });
    }
    getProductsQuantity() {
        return Cart.getSummary().then((summary) => {
            return summary.products_summary.total_products_quantity;
        });
    }
    getGiftsQuantity() {
        return Cart.getSummary().then((summary) => {
            return summary.products_summary.total_gifts_quantity;
        });
    }
    getTotalProducts() {
        return Cart.getSummary().then((summary) => {
            return summary.products_summary.total_products;
        });
    }
    getTotalGifts() {
        return Cart.getSummary().then((summary) => {
            return summary.products_summary.total_gifts;
        });
    }
    getProductsSummary() {
        return Cart.getSummary().then((summary) => {
            return {
                totalValue: summary.products_summary.total_value,
                productsValue: summary.products_summary.products_value,
                totalProductsQuantity: summary.products_summary.total_products_quantity,
                totalGiftsQuantity: summary.products_summary.total_gifts_quantity,
                totalProducts: summary.products_summary.total_products,
                totalGifts: summary.products_summary.total_gifts,
            };
        });
    }
}
